<ion-header [translucent]="true" class="ion-no-border">
  <ion-toolbar>
    <ion-row [ngClass]="title!='Home'?'header-ion-row':'header-ion-row-home'">
      <ion-col>

        <!-- @if (title =='login') {
        <ion-row>
          <ion-col size="12" style="text-align: end;" >

            <ion-icon class="close-dialog" name="close"  >
            </ion-icon>
          </ion-col>
        </ion-row>
        }@else { -->
        @if (title!='Home') {
          <ion-icon class="back-icon" src="assets/icon/back-arrow.svg" (click)="myBackButton(title)">
          </ion-icon>
        
          <ion-text (click)=" myBackButton(title)" class="title">{{title}}</ion-text>
          @if (title=='Login' || title=="New User Registration") {
            <ion-icon (click)="closeLoginDialog()" class="close-dialog" name="close"></ion-icon>
          }
        } @else{
          <div class="home-toolbar-row">
            <button class="toolbar-avatar" (click)="myAccount()" aria-label="My Account">
              <ion-icon name="person-outline"></ion-icon>
            </button>

            <div class="toolbar-center">
              @if (isLoggedIn ) {
              @if (selectedCity?.name) {
                <button type="button" class="toolbar-location-chip" (click)="ChangeCity()">
                  <span class="toolbar-location-icon-wrap">
                    <ion-icon name="location-outline"></ion-icon>
                  </span>
                  <span class="toolbar-location-copy">
                    <span class="toolbar-location-kicker">Your Location</span>
                    <span class="toolbar-location-text">{{ selectedCity?.name }}</span>
                  </span>
                  <ion-icon name="chevron-down-outline" class="toolbar-location-chevron"></ion-icon>
                </button>
              } @else {
                <button type="button" class="toolbar-location-chip toolbar-location-chip-cta" (click)="ChangeCity()">
                  <span class="toolbar-location-icon-wrap">
                    <ion-icon name="location-outline"></ion-icon>
                  </span>
                  <span class="toolbar-app-title">Select Your City</span>
                  <ion-icon name="chevron-down-outline" class="toolbar-location-chevron"></ion-icon>
                </button>
              }
            }
            </div>
          

            @if (isLoggedIn) {
              <button class="toolbar-action-btn" (click)="shortlist()" aria-label="Shortlist">
                <ion-icon name="heart" class="toolbar-heart-icon"></ion-icon>
              </button>
            } @else {
              <div class="toolbar-action-placeholder"></div>
            }
          </div>
        }
        @if (title=='My Properties') {          
          <ion-text style="float: inline-end;margin-right: 10px;cursor:pointer;" (click)="AddNewProp(isLeadSelected)">Add
          {{isLeadSelected}}</ion-text>
          <ion-icon style="font-size: 20px;float: inline-end;margin-right: 5px; cursor: pointer; "
          name="add-circle-outline" (click)="AddNewProp(isLeadSelected)"></ion-icon>
          
          @if (isLeadSelected === 'Lead' || isLeadSelected === 'Project') {
            <ion-icon  style="float: inline-end;margin-right: 22px;cursor:pointer;font-size: 22px;" name="link-outline" (click)="openLinkLeadDialog()"></ion-icon>
          }
        }

      @if (title=='Agent Properties') {
        <!-- <ion-button class="addpro-btn" (click)="AddNewProp(isLeadSelected)"> -->
        <ion-text style="float: inline-end;margin-right: 10px;cursor: pointer;" (click)="exportProperties()">Export
        Properties</ion-text>

        <ion-icon style="font-size: 20px;float: inline-end;margin-right: 5px;cursor: pointer;" name="download-outline"
        (click)="exportProperties()"></ion-icon>

      <!-- </ion-button> -->
    <!-- </ion-button> -->
  }
</ion-col>
</ion-row>
</ion-toolbar>
</ion-header>

<ion-modal class="modal-add-image" [isOpen]="isImagePreview" [canDismiss]="canDismiss" #previewModal id="image-preview"
  trigger="">
  <ng-template>
    <ion-header>
      <div  class="dialog-header">
        <ion-row class="ion-no-padding">
          <ion-col size="7" class="ion-no-padding">
            <ion-button class="close-button" (click)="dismissdialog()">
              <ion-icon name="close"></ion-icon>
              <ion-title style="margin-left: 10px;">Image Preview</ion-title>
            </ion-button>
          </ion-col>

        </ion-row>

      </div>
    </ion-header>

    <ion-content>
      <form [formGroup]="form" (ngSubmit)="exportProperties()">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Date range</mat-label>
          <mat-date-range-input [rangePicker]="picker" [min]="minDate" [max]="maxDate" formGroupName="range">
            <input matStartDate placeholder="Start date" formControlName="start" />
            <input matEndDate placeholder="End date" formControlName="end" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          @if (form.hasError('rangeInvalid')) {
            <mat-error>End date must be after start date.</mat-error>
          }
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit">Submit</button>
      </form>
    </ion-content>
    <ion-footer class="ion-text-end">
      <ion-button class="save-button" (click)="exportProperties()">Confirm</ion-button>
      <ion-button class="save-button" (click)="dismissdialog()">Close</ion-button>
    </ion-footer>
  </ng-template>
</ion-modal>

